import React from 'react';
import './SearchBar.css';

const SearchBar = ({ label, placeholder, value, onChange, classname }) => (
  <div className={`SearchBar ${classname}`}>
    <label htmlFor="search-input" className="SearchBar__label">
      {label}
    </label>
    <input
      id="search-input"
      type="search"
      className="SearchBar__input"
      placeholder={placeholder}
      value={value}
      onChange={(event) => onChange(event.target.value)}
    />
  </div>
);

export default SearchBar;
